/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  MyProfileDto,
  RemoveMemberResponseDto,
  UpdateProfileDto,
  UpdateProfileResponseDto,
  UsersControllerListMembersV1200,
  UsersControllerListMembersV1Params
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getUsersControllerGetMeV1Url = () => {




  return `/v1/users/me`
}

/**
 * @summary The caller's own profile
 */
export const usersControllerGetMeV1 = async ( options?: RequestInit): Promise<MyProfileDto> => {

  return apiRequest<MyProfileDto>(getUsersControllerGetMeV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersControllerGetMeV1QueryKey = () => {
    return [
    `/v1/users/me`
    ] as const;
    }


export const getUsersControllerGetMeV1QueryOptions = <TData = Awaited<ReturnType<typeof usersControllerGetMeV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetMeV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersControllerGetMeV1QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersControllerGetMeV1>>> = ({ signal }) => usersControllerGetMeV1({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetMeV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersControllerGetMeV1QueryResult = NonNullable<Awaited<ReturnType<typeof usersControllerGetMeV1>>>
export type UsersControllerGetMeV1QueryError = unknown


export function useUsersControllerGetMeV1<TData = Awaited<ReturnType<typeof usersControllerGetMeV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetMeV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerGetMeV1>>,
          TError,
          Awaited<ReturnType<typeof usersControllerGetMeV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersControllerGetMeV1<TData = Awaited<ReturnType<typeof usersControllerGetMeV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetMeV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerGetMeV1>>,
          TError,
          Awaited<ReturnType<typeof usersControllerGetMeV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersControllerGetMeV1<TData = Awaited<ReturnType<typeof usersControllerGetMeV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetMeV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The caller's own profile
 */

export function useUsersControllerGetMeV1<TData = Awaited<ReturnType<typeof usersControllerGetMeV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetMeV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersControllerGetMeV1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUsersControllerUpdateMeV1Url = () => {




  return `/v1/users/me`
}

/**
 * @summary Update own profile (name, avatar)
 */
export const usersControllerUpdateMeV1 = async (updateProfileDto: UpdateProfileDto, options?: RequestInit): Promise<UpdateProfileResponseDto> => {

  return apiRequest<UpdateProfileResponseDto>(getUsersControllerUpdateMeV1Url(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProfileDto)
  }
);}





export const getUsersControllerUpdateMeV1QueryKey = (updateProfileDto?: UpdateProfileDto,) => {
    return [
    'PATCH', `/v1/users/me`, updateProfileDto
    ] as const;
    }


export const getUsersControllerUpdateMeV1QueryOptions = <TData = Awaited<ReturnType<typeof usersControllerUpdateMeV1>>, TError = unknown>(updateProfileDto: UpdateProfileDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerUpdateMeV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersControllerUpdateMeV1QueryKey(updateProfileDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersControllerUpdateMeV1>>> = ({ signal }) => usersControllerUpdateMeV1(updateProfileDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersControllerUpdateMeV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersControllerUpdateMeV1QueryResult = NonNullable<Awaited<ReturnType<typeof usersControllerUpdateMeV1>>>
export type UsersControllerUpdateMeV1QueryError = unknown


export function useUsersControllerUpdateMeV1<TData = Awaited<ReturnType<typeof usersControllerUpdateMeV1>>, TError = unknown>(
 updateProfileDto: UpdateProfileDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerUpdateMeV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerUpdateMeV1>>,
          TError,
          Awaited<ReturnType<typeof usersControllerUpdateMeV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersControllerUpdateMeV1<TData = Awaited<ReturnType<typeof usersControllerUpdateMeV1>>, TError = unknown>(
 updateProfileDto: UpdateProfileDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerUpdateMeV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerUpdateMeV1>>,
          TError,
          Awaited<ReturnType<typeof usersControllerUpdateMeV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersControllerUpdateMeV1<TData = Awaited<ReturnType<typeof usersControllerUpdateMeV1>>, TError = unknown>(
 updateProfileDto: UpdateProfileDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerUpdateMeV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Update own profile (name, avatar)
 */

export function useUsersControllerUpdateMeV1<TData = Awaited<ReturnType<typeof usersControllerUpdateMeV1>>, TError = unknown>(
 updateProfileDto: UpdateProfileDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerUpdateMeV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersControllerUpdateMeV1QueryOptions(updateProfileDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUsersControllerListMembersV1Url = (params?: UsersControllerListMembersV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/users?${stringifiedParams}` : `/v1/users`
}

/**
 * @summary List the members of the caller’s agency (paginated, searchable, orderable)
 */
export const usersControllerListMembersV1 = async (params?: UsersControllerListMembersV1Params, options?: RequestInit): Promise<UsersControllerListMembersV1200> => {

  return apiRequest<UsersControllerListMembersV1200>(getUsersControllerListMembersV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersControllerListMembersV1QueryKey = (params?: UsersControllerListMembersV1Params,) => {
    return [
    `/v1/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersControllerListMembersV1QueryOptions = <TData = Awaited<ReturnType<typeof usersControllerListMembersV1>>, TError = unknown>(params?: UsersControllerListMembersV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerListMembersV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersControllerListMembersV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersControllerListMembersV1>>> = ({ signal }) => usersControllerListMembersV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersControllerListMembersV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersControllerListMembersV1QueryResult = NonNullable<Awaited<ReturnType<typeof usersControllerListMembersV1>>>
export type UsersControllerListMembersV1QueryError = unknown


export function useUsersControllerListMembersV1<TData = Awaited<ReturnType<typeof usersControllerListMembersV1>>, TError = unknown>(
 params: undefined |  UsersControllerListMembersV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerListMembersV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerListMembersV1>>,
          TError,
          Awaited<ReturnType<typeof usersControllerListMembersV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersControllerListMembersV1<TData = Awaited<ReturnType<typeof usersControllerListMembersV1>>, TError = unknown>(
 params?: UsersControllerListMembersV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerListMembersV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerListMembersV1>>,
          TError,
          Awaited<ReturnType<typeof usersControllerListMembersV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersControllerListMembersV1<TData = Awaited<ReturnType<typeof usersControllerListMembersV1>>, TError = unknown>(
 params?: UsersControllerListMembersV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerListMembersV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the members of the caller’s agency (paginated, searchable, orderable)
 */

export function useUsersControllerListMembersV1<TData = Awaited<ReturnType<typeof usersControllerListMembersV1>>, TError = unknown>(
 params?: UsersControllerListMembersV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerListMembersV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersControllerListMembersV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUsersControllerRemoveMemberV1Url = (id: string,) => {




  return `/v1/users/${id}`
}

/**
 * @summary Remove a member from the agency (root user only)
 */
export const usersControllerRemoveMemberV1 = async (id: string, options?: RequestInit): Promise<RemoveMemberResponseDto> => {

  return apiRequest<RemoveMemberResponseDto>(getUsersControllerRemoveMemberV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUsersControllerRemoveMemberV1QueryKey = (id: string,) => {
    return [
    'DELETE', `/v1/users/${id}`
    ] as const;
    }


export const getUsersControllerRemoveMemberV1QueryOptions = <TData = Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersControllerRemoveMemberV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>> = ({ signal }) => usersControllerRemoveMemberV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersControllerRemoveMemberV1QueryResult = NonNullable<Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>>
export type UsersControllerRemoveMemberV1QueryError = unknown


export function useUsersControllerRemoveMemberV1<TData = Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>,
          TError,
          Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersControllerRemoveMemberV1<TData = Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>,
          TError,
          Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersControllerRemoveMemberV1<TData = Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Remove a member from the agency (root user only)
 */

export function useUsersControllerRemoveMemberV1<TData = Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerRemoveMemberV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersControllerRemoveMemberV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






